import React, { useEffect, useState, useRef, useCallback } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./index.css";
// import LazyLoad from "react-lazy-load";
const PopUps = ({ Popupss }) => {
  const [visible, setVisible] = React.useState(false);
  const skipRef = useRef(null);
  const modalRef = useRef(null);
  useEffect(() => {
    let pop_status = localStorage.getItem("pop_status");
    if (!pop_status) {
      setVisible(true);
      localStorage.setItem("pop_status", 1);
    }
  }, []);
  useEffect(() => {
    if (visible && skipRef.current) {
      skipRef.current.focus();
    }
  }, [visible]);
  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape") {
      document.querySelector(".show")?.classList.remove("show");
      setVisible(false);
    }
    if (e.key === "Tab" && modalRef.current) {
      const focusable = modalRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (focusable.length) {
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }, []);
  window.onbeforeunload = function () {
    localStorage.removeItem("pop_status");
  };

  if (!visible) return null;
  return (
    <>
      {Popupss.length == 0 ? (
        ""
      ) : (
        <div className="MainPopups">
          <div
            className="modal fade show"
            id="exampleModal"
            tabIndex={-1}
            aria-label="Promotional Popup"
            aria-hidden="true"
            ref={modalRef}
            onKeyDown={handleKeyDown}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <button
                    className="skip_btns"
                    ref={skipRef}
                    onClick={() => {
                      document.querySelector(".show")?.classList.remove("show");
                      setVisible(false);
                    }}
                  >
                    Skip <i className="zmdi zmdi-arrow-right"></i>
                  </button>
                  <Carousel
                    autoPlay={true}
                    infiniteLoop={true}
                    swipeable={true}
                    showStatus={false}
                    showIndicators={false}
                    showThumbs={false}
                    interval={3000}
                  >
                    {Popupss?.map((Pop, index) => {
                      return (
                        <div key={index}>
                          {Pop.file && <img src={Pop.file} alt="" />}
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PopUps;
